module.exports = __webpack_public_path__ + "static/32-thumb-72bb0ad0e34c239d59a9985ec3c830e3.jpg";